export default __webpack_public_path__ + "static/media/dawn.35e0dc19.jpg";